import { render } from "./FooterApp.vue?vue&type=template&id=361e25ea&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"

import "./FooterApp.vue?vue&type=style&index=0&id=361e25ea&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe/Safe_Sites_Modifs/SAFE_MED/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361e25ea"]])

export default __exports__